import { FC } from "react";

import { CommunicationPreferenceFormType } from "@simplyk/common";

import { trpc } from "@/common/helpers/trpc";
import { useTranslate } from "@/common/hooks/useTranslate";
import { QuestionCard } from "@/features/LiveFormEditor/Steps/StepQuestionsV4/QuestionCard/QuestionCard";
import { COMMUNICATION_PREFERENCES_QUESTION_KEY } from "@/features/LiveFormEditor/Steps/StepQuestionsV4/types";
import { Checkbox, Lists } from "@/icons/outlined";

interface CommunicationPreferencesCardProps {
  formId: string;
  formType: CommunicationPreferenceFormType;
  onEdit: () => void;
  onDelete?: () => void;
  deleteDisabledTooltip?: string;
  showDisabledReorderHandle?: boolean;
}

export const CommunicationPreferencesCard: FC<CommunicationPreferencesCardProps> = ({
  formId,
  formType,
  onEdit,
  onDelete,
  deleteDisabledTooltip,
  showDisabledReorderHandle,
}) => {
  const { t } = useTranslate();

  const { data } = trpc.getFormCommunicationPreferences.useQuery({ formId, formType });

  const selectedNames = (data?.selectedContactListIds ?? [])
    .map((contactListId) => data?.options.find((option) => option.contactListId === contactListId)?.name)
    .filter(Boolean);

  if (selectedNames.length === 0) {
    return null;
  }

  const icon = selectedNames.length > 1 ? <Lists /> : <Checkbox />;

  return (
    <QuestionCard
      icon={formType === CommunicationPreferenceFormType.Ticketing ? undefined : icon}
      label={t("dashboard", "communicationPreferences.questionTitle")}
      subtitle={selectedNames.join(t("dashboard", "communicationPreferences.separator"))}
      onEdit={onEdit}
      onDelete={deleteDisabledTooltip ? undefined : onDelete}
      deleteDisabledTooltip={deleteDisabledTooltip}
      showDisabledReorderHandle={showDisabledReorderHandle}
      questionKey={COMMUNICATION_PREFERENCES_QUESTION_KEY}
    />
  );
};
